import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const deleteAdjustmentSlice = createSlice({
  name: 'deleteAdjustmentSlice',
  initialState: {},
  reducers: {
    deletePaymentAdjustment: (
      _,
      _action: PayloadAction<{ claimId: string | number; adjustmentId: string | number }>,
    ) => {},
    deleteBenefitAdjustment: (
      _,
      _action: PayloadAction<{ claimId: string | number; adjustmentId: string | number }>,
    ) => {},
  },
});

export const { deletePaymentAdjustment, deleteBenefitAdjustment } = deleteAdjustmentSlice.actions;

export const deleteAdjustmentReducer = deleteAdjustmentSlice.reducer;
export const deleteAdjustmentReducerPath = deleteAdjustmentSlice.reducerPath;
